<template>
  <div class="my-team-list">
    <div class="member-list">
      <div 
        v-for="member in memberList" 
        :key="member.idNumber"
        class="member-item"
        :class="{ 'expanded': expandedMember === member.idNumber }"
      >
        <!-- 成员信息 -->
        <div class="member-info">
          <div class="member-details">
            <h3 class="member-name">{{ member.receiverName }}</h3>
            <div class="member-id">{{ formatIdNumber(member.idNumber) }}</div>
            <div class="member-btn">
              <span class="btn" @click="openAddMember(member, 'edit')">编辑</span>
              <span class="btn" @click="deleteMember(member.id)">删除</span>
              <!-- <span class="expand-icon"  :class="{ 'rotated': expandedMember === member.idNumber }">
                <img class="arrow" src="@/assets/image/nsale/arrow-fill-red.png" alt="">
              </span> -->
            </div>
          </div>
        </div>
        <!-- 月度体现信息 -->
        <!-- <transition name="slide-down">
          <div v-show="expandedMember === member.idNumber" class="card-records">
            <div v-if="member.bankList && member.bankList.length">
              <div class="record-info" v-for="bankCard in member.bankList" :key="bankCard.id">
                <div class="info-item">
                  <label class="label">银行名称</label>
                  <span class="value">{{ bankCard.bankName }}</span>
                </div>
                <div class="info-item">
                  <label class="label">支行名称</label>
                  <span class="value">{{ bankCard.bankBranchName }}</span>
                </div>
                <div class="info-item">
                  <label class="label">银行账号</label>
                  <span class="value">{{ bankCard.bankCardCode }}</span>
                </div>
              </div>
            </div>
            <div class="no-data" v-else>该成员下暂无银行卡哦～</div>
          </div>
        </transition> -->
      </div>
      <div class="fix-btn-box">
        <div class="fix-btn" @click="openAddMember(null, 'add')">添加成员</div>
      </div>
      <div class="no-data" v-if="memberList.length === 0">
        {{ isInit ? '正在查询中...' : '暂无成员哦，快去添加吧～' }}
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api.js"
import moment from 'moment'
export default {
  name: 'myTeamList',
  data() {
    return {
      cuswebuserid: this.$route.query.userId,
      isInit: true, // 是否是init
      expandedMember: null, // 展开成员控制
      memberList: [],
    }
  },
  created() {
    this.getMemberTeamList()
  },
  methods: {
    moment,
    getMemberTeamList() {
      api.queryMemberTeamList({
        cuswebuserid: this.cuswebuserid
      }).then(res => {
        this.isInit = false
        let data = res.data
        this.memberList = data.content || []
      })
    },
    // 切换成员展开状态
    toggleMember(memberId) {
      this.expandedMember = this.expandedMember === memberId ? null : memberId
    },
    // 格式化身份证号
    formatIdNumber(idNumber) {
      if (!idNumber) return ''
      return idNumber.replace(/^(.{2}).*(.{2})$/, (match, p1, p2) => {
        return p1 + '*'.repeat(match.length - 4) + p2;
      })
    },
    // 删除成员
    deleteMember(id) {
    
      this.$dialog.confirm({
        title: '提示',
        message: '确定删除该成员吗？'
      }).then(() => {
        api.deleteMember({id}).then((res) => {
          let data = res.data
          if(data.returnCode == '00') {
            this.$toast("删除成功");
            this.getMemberTeamList()
            return
          }
          this.$toast(res.returnMsg)
        })
      })
    },
    // 打开添加成员页面
    openAddMember(member, type){
      if(type === 'edit') {
        sessionStorage.setItem('member', JSON.stringify(member))
      }
      this.$router.push(`/bs/my-team/add-member?type=${type}&userId=${this.cuswebuserid}`)
    }
  }
}
</script>

<style lang="scss" scoped>
// 基础样式 - 手机端优先
.my-team-list {
  padding: 18px 12px 100px 12px;
  background-color: #fefefe;
  min-height: 100vh;
  box-sizing: border-box;
  font-size: 12px;
  .no-data {
    margin-top: 100px;
    color: #999;
  }
}
.member-list {
  margin-bottom: 20px;
}

.member-item {
  background: white;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s linear;
}

.member-info {
  display: flex;
  align-items: center;
  padding: 18px 12px;
  cursor: pointer;
  transition: background-color 0.3s linear;
  
  &:active {
    background-color: #f8f9fa;
  }
}
.card-records {
  margin-top: 12px;
  background-color: #fcfcfc;
  .no-data {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-size: 14px;
    color: #ccc;
    padding: 32px 0;
  }
}
.member-details {
  display: flex;
  flex: 1;
  align-items: center;
  
  .member-name {
    width: 66px;
    font-size: 12px;
    font-weight: bold;
    color: #333;
    margin: 0 0 3px 0;
    margin-right: 6px;
  }
  
  .member-id {
    font-size: 12px;
    color: #666;
  }
  .member-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .btn {
      font-size: 11px;
      background-color: #FF7C6D;
      color: #fff;
      margin-left: 12px;
      border-radius: 4px;
      padding: 6px 10px;
    }
    .expand-icon {
      margin-left: 12px;
      padding: 0 6px;
      transition: transform 0.3s linear;
      &.rotated {
        transform: rotate(180deg);
      }
      .arrow {
        width: 14px;
      }
    }
  }
}
.record-info {
  padding: 18px 14px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-bottom: 1px solid #eee;
  .info-item {
    display: flex;
    justify-content: space-between;
    .value {
      flex: 1;
      text-align: right;
    }
  }
}
// 动画效果
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
  max-height: 500px;
}

.slide-down-enter,
.slide-down-leave-to {
  max-height: 0;
  opacity: 0;
}
.fix-btn-box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 80px;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: 0 0px 4px rgba(0, 0, 0, 0.1);
  padding: 0 24px;
  box-sizing: border-box;
  .fix-btn {
    margin-top: 12px;
    text-align: center;
    font-size: 12px;
    height: 40px;
    line-height: 40px;
    background-color: #FF7C6D;
    color: #fff;
    border-radius: 24px;
    font-size: 14px;
    font-weight: bold;

  }
}

</style>